import { useEffect, useState, useRef, useMemo,useCallback } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';

import redBg from 'assets/images/Map-Marker-red.png';
import orangeBg from 'assets/images/Map-Marker-orange.png';
import granitexLogo from 'assets/images/granitexLogo.png'
import useAlert from "hooks/useAlert";

// Customize the marker icon
const customIcon = new L.Icon({
  iconUrl: require('assets/images/marker-icon.png'),
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

const DistributerMap = ({distributerList, parseContent, filterSearch, searchTerm, selectedLocation}) => {
  const [userPosition, setUserPosition] = useState(null);
  const CenterMapOnLocation = ({ selectedLocation }) => {
    const map = useMap();
  
    useEffect(() => {
      if (selectedLocation) {
        map.flyTo([selectedLocation.lat, selectedLocation.lng], 15); // Zoom level 15
        // window.scrollTo(0,0)
      }
    }, [selectedLocation, map]);
  
    return null; // This component only controls the map; it doesn't render anything visible
  };
  

  useEffect(() => {
    if(userPosition){
      filterSearch({ filters : {...searchTerm.filters, location : {lat : userPosition.lat, lng : userPosition.lng}} })
    }
  }, [userPosition])
  
  return (
    <MapContainer 
        center={userPosition || [51.505, -0.09]} // Default to London if no location
        zoom={10} // Zoom closer if userPosition is set
        style={{ height: '55vh', width: '90%' }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        
      />
      <CenterMapOnLocation selectedLocation={selectedLocation} />
      <LocationMarker setUserPosition={setUserPosition} />
      <CustomMarker
          position={[36.698882, 3.1733833]}
          icon={granitexLogo}
          isGranitex={true}
        >
          <Popup>
            <div>
              <h3>Granitex Building Chemicals</h3>
              {parseContent("<p>bienvenue  chez granitex</p>")}
            </div>
          </Popup>
        </CustomMarker>
      {distributerList && distributerList.map(distributer => distributer.location?.coordinates?.lat ? (
        <CustomMarker
          key={distributer.id}
          position={[distributer.location.coordinates.lat, distributer.location.coordinates.lng]}
          icon={`${process.env.REACT_APP_PUBLIC_URL}/img/distributer/${distributer.photoURL}`}
          isGranitex={false}
          eventHandlers={{
            click: () => {}
          }}
        >
          <Popup>
            <div>
              <h3>{distributer.companyName || distributer.displayName}</h3>
              {parseContent(distributer.description)}
            </div>
          </Popup>
        </CustomMarker>
      ) : null)}
    </MapContainer>
  );
};

const LocationMarker = ({setUserPosition})=> {
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state
  const [draggable, setDraggable] = useState(false)
  const markerRef = useRef(null)
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current
        if (marker != null) {
          setPosition(marker.getLatLng())
        }
      },
    }),
    [],
  )
  const toggleDraggable = useCallback(() => {
    setDraggable((d) => !d)
  }, [])

  const {showAlerts} = useAlert();

  const map = useMapEvents({
    locationfound(e) {
      setPosition(e.latlng);
      setUserPosition(e.latlng);
      map.flyTo(e.latlng, map.getZoom());
      setLoading(false);
    },
    locationerror() {
      setLoading(false); // Stop loading if location isn't found
      showAlerts({
      title : "Location Alert",
      type  : "toast",
      msg :  "Veuillez autoriser la détection de votre position en cliquant sur 'Autoriser', puis actualisez la page.",
      color :"info"
    })
    },
  });

  useEffect(() => {
    map.locate(); // Automatically locate on component mount
  }, [map]);

  return position === null ? (
    loading ? <p>Locating...</p> : <p>Location not found.</p> 
  ) : (
    <Marker 
      draggable={draggable}
      eventHandlers={eventHandlers}
      position={position}
      ref={markerRef}
      >
      <Popup><span onClick={toggleDraggable}>You are here</span></Popup>
    </Marker>
  );
}

// CustomMarker Component
const CustomMarker = ({ position, icon,eventHandlers,isGranitex, ...props }) => {
  // Create a custom icon using a React component or HTML
  const fallbackIcon = createCustomIcon(icon,isGranitex);
  return <Marker eventHandlers={{
            ...eventHandlers
            }}
            position={position} 
            icon={fallbackIcon}
            {...props} />;
};

const createCustomIcon = (icon, isGranitex) => {
  return new L.DivIcon({
    className: 'custom-marker',
    html: `
      <div class="custom-marker-content" style="position : relative; heigth:41px, width:25px">
        <img 
          src="${isGranitex ? granitexLogo : icon}" 
          alt="Custom Marker" 
          style="width: 32px;
          height: 32px;
          border-radius: 50%;
          left: 12px;
          top: 4px;
          background-color: white;
          position :absolute"
          onError="this.style.display ='none'"
        />
        <img 
          src="${isGranitex ? orangeBg : redBg }" 
          alt="Custom Marker" 
          style="width : 56px; height :56px"
          onError="this.style.display='none';"
        />
      </div>`,
  });
};

export default DistributerMap;